import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { updateAmazonSellerAccount } from '../components/API/amazon';
import LoadingBackdrop from '../components/LoadingBackdrop';

export default function AmazonSellerRedirect() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  async function handleAmazonRedirect() {
    const url = new URLSearchParams(window.location.search);
    let redirectUri = null;
    let lines = null;
    if (
      url.get('spapi_oauth_code') &&
      url.get('selling_partner_id') &&
      url.get('state')
    ) {
      setLoading(true);
      const authCode = url.get('spapi_oauth_code');
      const sellerId = url.get('selling_partner_id');
      const state = url.get('state');
      try {
        const split = state.split('_');
        const internalAccountId = split[0];
        redirectUri = split[1];
        lines = split.length > 2 ? split[2] : null;
        await Promise.all([
          updateAmazonSellerAccount(internalAccountId, sellerId, authCode),
        ]);
      } catch (error) {
        console.error('Error saving Amazon seller data', error);
      }
      setLoading(false);
    }
    let finalUrl = redirectUri ? redirectUri : '/';
    if (lines) {
      finalUrl += `?lines=${lines}`;
    }
    history.push(finalUrl);
  }

  useEffect(() => {
    handleAmazonRedirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <LoadingBackdrop open={loading} />
    </div>
  );
}
